<template>
    <ModalBase
        :name="'borrar-sancion-' + sancion.id"
        :title="'Borrar sanción de ' + deportistaName"
        @close="close"
    >
        <div class="tw:space-y-6">
            <div>
                <p class="tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wider tw:text-gray-400 tw:mb-3">Datos del deportista</p>
                <div class="tw:grid tw:grid-cols-2 tw:gap-4">
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Nombre</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ deportista.name || deportista.nombre || '-' }}</p>
                    </div>
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Apellidos</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ deportista.surnames || deportista.apellidos || '-' }}</p>
                    </div>
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">DNI</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ deportista.dni || '-' }}</p>
                    </div>
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Email</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ deportista.email || '-' }}</p>
                    </div>
                </div>
            </div>

            <div>
                <p class="tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wider tw:text-gray-400 tw:mb-3">Datos de la sanción</p>
                <div class="tw:grid tw:grid-cols-2 tw:gap-4">
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Fecha</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ sancion.fecha }}</p>
                    </div>
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Sin jugar hasta</p>
                        <p class="tw:text-sm tw:text-gray-900">{{ sancion.sin_jugar_hasta }}</p>
                    </div>
                    <div>
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Acceso bloqueado</p>
                        <p class="tw:text-sm tw:text-gray-900">
                            <CheckOrCross :condition="sancion.bloquear_acceso"/>
                        </p>
                    </div>
                    <div class="tw:col-span-2">
                        <p class="tw:text-xs tw:text-gray-500 tw:font-semibold tw:mb-1">Motivo</p>
                        <p class="tw:text-sm tw:text-gray-900" v-html="sancion.motivo"></p>
                    </div>
                </div>
            </div>
        </div>

        <template #footer>
            <div class="tw:flex tw:justify-end">
                <Button variant="danger" @click="handleConfirm">SI, BORRAR</Button>
            </div>
        </template>
    </ModalBase>
</template>

<script setup>
    import { ref, computed, getCurrentInstance } from 'vue'
    import CheckOrCross from '@/components/backend/components/CheckOrCross.vue'
    import ModalBase from '@/modules/admin/ui/ModalBase.vue'
    import Button from '@/modules/admin/ui/Button.vue'

    const props = defineProps({
        deportista: {
            type: Object,
            required: true
        },
        sancion: {
            type: Object,
            required: true
        },
        onConfirm: {
            type: Function,
            required: true
        }
    })

    const emit = defineEmits(['close'])
    const instance = getCurrentInstance()
    const loading = ref(false)

    const deportistaName = computed(() => {
        const name = props.deportista.name || props.deportista.nombre || ''
        const surnames = props.deportista.surnames || props.deportista.apellidos || ''
        return [name, surnames].filter(Boolean).join(' ')
    })

    const close = () => {
        instance.proxy.$modal.hide('borrar-sancion-' + props.sancion.id)
        emit('close')
    }

    const handleConfirm = async() => {
        loading.value = true
        try {
            await props.onConfirm(props.sancion.id)
        } catch {
            // Error handled by composable via toast
        } finally {
            loading.value = false
        }
        close()
    }
</script>
